export default __webpack_public_path__ + "static/media/Img6@2x.72ed998d.jpg";